const money = (value, currency) => new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency,
}).format(Number(value));

export const transformModulePriceRow = (record = {}, currency = 'USD', messages = {}) => {
  const selectedCurrency = String(currency || 'USD').trim().toUpperCase();
  let annualPrices = record.annual_prices_by_currency;
  if (typeof annualPrices === 'string') {
    try { annualPrices = JSON.parse(annualPrices); } catch { annualPrices = {}; }
  }
  annualPrices = annualPrices && typeof annualPrices === 'object' ? annualPrices : {};

  let displayPrice;
  if (selectedCurrency === 'USD') {
    const storedCurrency = String(record.currency || 'USD').trim().toUpperCase();
    displayPrice = storedCurrency !== 'USD' && record.price !== null && record.price !== undefined
      ? `${messages.legacyCurrencyReview || 'Revisar valor legado'} (${money(record.price, storedCurrency)})`
      : record.price === null || record.price === undefined || record.price === ''
      ? (messages.unconfigured || 'Não configurado')
      : money(record.price, 'USD');
  } else {
    const annual = annualPrices[selectedCurrency];
    displayPrice = annual?.price === null || annual?.price === undefined
      ? (messages.localPricePending || 'Preço local pendente')
      : money(annual.price, selectedCurrency);
  }

  const suggestionIsReady = record.suggestion_status === 'ready'
    && record.suggested_price_usd !== null
    && record.suggested_price_usd !== undefined;
  const suggestedPriceDisplay = suggestionIsReady
    ? money(record.suggested_price_usd, 'USD')
    : (messages.suggestionPending || 'Pendente');

  return {
    ...record,
    annual_prices_by_currency: annualPrices,
    display_price: displayPrice,
    suggested_price_display: suggestedPriceDisplay,
  };
};
